import { useEffect, useState } from "react"
import UMCDomainContentLayout from "../common/UMCDomainContentLayout"
import { useDispatch, useSelector } from "react-redux"
import { checkIfAnyModified, deepMergeObjects, getDomainsView, validateLinks } from "../../utils/SchemaParseUtils"
import { UUM_URL } from "../../utils/Config"
import { setProfileDetailData, setProfileDetailSchema } from "../../store/reducers/UUMReducer"
import { getSchemaDataResponse } from "../../store/actions/CommonActions"
import _ from "lodash"
import { setBaseMergeData, setContentLoading, setCurrentMergedData, setIsUnSavedDataExists, setUmcNotification } from "../../store/reducers/CommonReducer"
import { createUserProfile, updateUserProfile } from "../../store/actions/UUMActions"
import { message } from "antd"
import { validateAllMandatoryAttr } from "../../utils/ValidationUtils"
import { UPDATE } from "../../utils/Constants"
import confirmModal from "../common/confirmModal"
import { getProfileData } from "../../store/actions/UUMActions"
import { getTranslated } from "../../utils/CommonUtils";

import { sendGTMEvent } from "../../utils/GTMUtils"

const CreateUserProfDetailView = (props) => {

    const [domains, setDomains] = useState([])
    const [validateState, setValidateState] = useState(false)

    const profileDetailSchema = useSelector(state => state.uum.profileDetailSchema)
    const profileDetailData = useSelector(state => state.uum.profileDetailData)
    const currentMergedData = useSelector((state) => state.common.currentMergedData)
    const baseMergeData = useSelector((state) => state.common.baseMergeData)
    const dict = useSelector(state => state.common.dict)
    const isUnSavedDataExists = useSelector((state) => state.common.isUnSavedDataExists)

    const [messageApi, contextHolder] = message.useMessage()

    const dispatch = useDispatch()

    useEffect(() => {
        if (!Object.keys(profileDetailSchema).length) {
            const request = { url: `${UUM_URL}/schema/detail/easyuserprofile`, action: setProfileDetailSchema }
            dispatch(getSchemaDataResponse(request))
        }

        return (() => {
            dispatch(setCurrentMergedData(null))
            dispatch(setProfileDetailData(null))
        })
    }, [])

    useEffect(() => {
        if (props.selectedProfile) {
            // const request = { url: `${UUM_URL}/data/easyuserprofile/${props.selectedProfile}`, action: setProfileDetailData }
            // dispatch(getSchemaDataResponse(request))
            dispatch(getProfileData(props.selectedProfile, false))
        }
    }, [props.selectedProfile])

    useEffect(() => {
        if (profileDetailSchema?.domain && profileDetailData?.domain) {
            const mergedData = deepMergeObjects(profileDetailSchema.domain, profileDetailData.domain)
            let updatedData = props.mode === UPDATE ? mergedData : resetProfileName(mergedData)
            updatedData = validateLinks(updatedData)

            dispatch(setCurrentMergedData(updatedData))
            dispatch(setBaseMergeData(updatedData))
            dispatch(setContentLoading(false))
        }
    }, [profileDetailSchema, profileDetailData])

    useEffect(() => {
        setDomains(currentMergedData)
        dispatch(setIsUnSavedDataExists(checkIfAnyModified(currentMergedData)))
    }, [currentMergedData])


    const resetProfileName = (domain) => {
        if (domain?.length && domain[0]?.subdomain?.length && domain[0]?.subdomain[0]?.attribute?.length) { // hardcoded index to prevent unnecessary recursion of domain obj
            domain[0]?.subdomain[0]?.attribute?.map(attr => attr.value = (attr.id === "profilename") ? "" : attr.value)
            domain[0]?.subdomain[1]?.attribute?.map(attr => attr.value = (attr.id === "profiledescription") ? "" : attr.value)

            return domain
        }

        return domain
    }

    const HandleOK = () => {

        const validateResponse = (status, data) => {
            if (status) {
                props.backToListView(true)
                dispatch(setCurrentMergedData(null))
            } else {
                dispatch(setContentLoading(false))
                confirmModal({
                    title:   data.errorResponse?.length > 0
                                ? getTranslated(dict, data.errorResponse[0]?.message)
                                : "LABEL_FAILED",
                    content: data?.errorMessage || "",
                    type: "error",
                    okText: "LABEL_OK"
                })
                
                // dispatch(setUmcNotification({
                //     type: "error",
                //     message: "Failed",
                //     description: data?.errorMessage || ""
                // }))
            }
        }

        const validateStatus = validateAllMandatoryAttr(currentMergedData)
        if (validateStatus) {
            setValidateState(false)
            dispatch(setContentLoading(true))

            // Send GTM event for user profile creation/update
            sendGTMEvent({
                event: "umc_easy_user_profiles",
                action: props.mode === UPDATE ? "Cust_profile_UPDATE_triggered" : "Cust_profile_CREATION_triggered"
            })

            if (props.mode === UPDATE) {
                dispatch(updateUserProfile(props.selectedProfile, (status) => {
                    validateResponse(status)
                }))
            } else {
                dispatch(createUserProfile((status,data) => {
                    validateResponse(status,data)
                }))
            }
        } else {
            // messageApi.open({
            //     type: 'error',
            //     content: 'Fill in all the mandatory fields!',
            //     style: {
            //         marginTop: '20vh',
            //     },
            // })
            setValidateState(true)
        }
    }

    const goBackHandler = () => {
        if (currentMergedData && isUnSavedDataExists) {
            confirmModal({
                title: "MSG_LEAVE_PAGE",
                content: "MSG_LOSE_CONFIG",
                onOk: () => {
                    props.changeCreateMode(true)
                }
            })
        }
        else {
            props.changeCreateMode(true)
        }
    }


    return <>
        {contextHolder}
        <UMCDomainContentLayout
            domains={getDomainsView(domains, { validateState: validateState, actionMode: props.mode, isReadOnly: props.isReadOnly }, dict)}
            backBtnLabel="LABEL_BACK"
            okBtnLabel={props.mode === UPDATE ? "LABEL_UPDATE" : "LABEL_CREATE"}
            isReadOnly={props.isReadOnly}
            goBackHandler={() => goBackHandler()}
            handleOK={() => HandleOK()}
        />
    </>
}

export default CreateUserProfDetailView